import { useTranslation } from "react-i18next";

import { styledHeaderText } from "../../styled";

import { DialogContextType } from "../../DialogComponents/FullScreenDialog";
import { styledHeaderSubTitle } from "../components/styledHeaderSubTitle";
import { useImportContext } from "../importContext";

export const useContext = (): DialogContextType => {
  const { t } = useTranslation("dialogs");
  const { step, file, importType } = useImportContext();

  return {
    title: {
      text: styledHeaderText(t("import.uploadData")),
      icon: "layers",
    },
    subTitle: step > 0 && file.name ? styledHeaderSubTitle(file.name, importType) : null,
    meta: {
      aliasLabel: t("import.layerName"),
      descriptionLabel: t("import.layerDescription"),
      loaderLabel: t("import.uploadLayerImage"),
    },
    attributes: {
      label: t("import.attributes"),
      icon: "table",
    },
  };
};
